/**
 * src/pages/WhatIsConsciousness/sections/StillUnanswered.tsx
 * ExpandList covering the big unanswered mysteries of consciousness science.
 */

import React from "react";
import { HelpCircle } from "lucide-react";
import { ExpandList } from "@/components/originBeyond/ExpandList";
import { UNANSWERED_CONSCIOUSNESS_QUESTIONS } from "../consciousnessData";
import "@/components/cosmic/cosmic.css";
export function StillUnanswered() {
  return <section className="w-full max-w-full min-w-0" aria-labelledby="unanswered-consciousness-heading">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="size-1.5 rounded-[1px] bg-primary rotate-45 shadow-[0_0_8px_1px_var(--glow-primary)] shrink-0" aria-hidden="true" />
            <span className="ql-eyebrow">Frontiers of the Mind</span>
          </div>
          <h2 id="unanswered-consciousness-heading" className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
            Still Unanswered
          </h2>
        </div>
        <p className="font-sans text-xs sm:text-sm text-muted-foreground max-w-md">
          Explore the active scientific and philosophical debates where consensus has not yet settled.
        </p>
      </div>

      <ExpandList items={UNANSWERED_CONSCIOUSNESS_QUESTIONS} defaultOpenId="hard-problem-deep" allowMultiple={false} />
    </section>;
}